import type { AppEnvironment } from "@freightsimple/api-runtime/appEnvironment";

// Deployment-environment detection and the canonical API/Dashboard URLs.
// Shared across FreightSimple web apps — the env names, the meta-tag
// mechanism, and the backend hosts are the same everywhere.

function detectEnvironment(): AppEnvironment {
  // Vite dev override
  const override = import.meta.env["VITE_LOCAL_OVERRIDE_ENVIRONMENT"];
  if (
    override === "preprod" ||
    override === "demo" ||
    override === "production"
  ) {
    return override;
  }

  // Meta tag, replaced by CI/CD at deploy time
  const meta = document.querySelector('meta[name="environment"]');
  const content = meta?.getAttribute("content") ?? "";

  if (content === "production") return "production";
  if (content === "demo") return "demo";
  if (content === "preprod") return "preprod";

  // Unreplaced token or missing = local development
  return "local";
}

export const environment: AppEnvironment = detectEnvironment();

export function isProduction(): boolean {
  return environment === "production";
}

export function isDemo(): boolean {
  return environment === "demo";
}

export function isLocal(): boolean {
  return environment === "local";
}

export function isLocalOverride(): boolean {
  return !!import.meta.env["VITE_LOCAL_OVERRIDE_ENVIRONMENT"];
}

export function apiServerUrl(): string {
  switch (environment) {
    case "local":
      return import.meta.env["VITE_FS_API_URL"] || "http://localhost:8001";
    case "preprod":
      return "https://api.fspreprod.com";
    case "demo":
      return "https://api.freightsimpledemo.com";
    case "production":
      return "https://api.freightsimple.com";
  }
}

export function dashboardBaseUrl(): string {
  switch (environment) {
    case "local":
      return (
        import.meta.env["VITE_FS_DASHBOARD_URL"] || "http://localhost:3001"
      );
    case "preprod":
      return "https://dashboard.fspreprod.com";
    case "demo":
      return "https://dashboard.freightsimpledemo.com";
    case "production":
      return "https://dashboard.freightsimple.com";
  }
}
